export default __webpack_public_path__ + "static/media/logobatikshibori.8c12687b.png";